<template>
  <div class=" mx-3  mt-2">
    <v-menu
      ref="menu1"
      v-model="menu1"
      offset-y
      max-width="290px"
      min-width="290px"
      :close-on-content-click="false"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="selectedSnoozeDate"
          readonly
          v-bind="attrs"
          v-on="on"
          label="Select date"
          prepend-icon="mdi-calendar"
        ></v-text-field>
      </template>
      <v-date-picker v-model="selectedSnoozeDate"></v-date-picker>
    </v-menu>
    <v-text-field v-model="snoozeNote" label="Note as to why the client's task are being snoozed"></v-text-field>
    <div class="d-flex justify-space-between">
      <v-btn
        class="mx-2 mt-1"
        :disabled="!snoozeNote || !selectedSnoozeDate"
        elevation="2"
        @click="updateSnoozeUntil()"
      >
        Save
      </v-btn>

      <v-btn v-if="snoozedUntil" class="mx-2 mt-1" :disabled="!snoozedUntil" elevation="2" @click="reset()">
        Reset snooze
      </v-btn>
    </div>
  </div>
</template>

<script>
import { UPDATE_PROFILE_MUTATION } from "@/constants/graphql/client/client";

export default {
  props: {
    userId: {
      type: String,
      required: true,
    },
    snoozedUntil: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      selectedSnoozeDate: this.snoozedUntil,
      menu1: false,
      snoozeNote: null,
    };
  },

  methods: {
    reset() {
      this.selectedSnoozeDate = null;
      this.snoozeNote = null;
      this.updateSnoozeUntil();
    },
    updateSnoozeUntil() {
      this.$apollo
        .mutate({
          mutation: UPDATE_PROFILE_MUTATION,
          variables: {
            userProfileInput: {
              userId: this.userId,
              taskPauseUntil: this.selectedSnoozeDate,
              taskPauseNote: this.snoozeNote,
            },
          },
        })
        .then((response) => {
          this.$emit("task-pause-until-updated");
          if (response.data.updateProfile.ok) {
            this.edit = false;
            this.snoozeNote = null;
            this.$toasted.success("Client's profile has been updated", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          } else {
            this.$toasted.error("Unable to update client's information. Sorry.", {
              icon: "alert",
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
  },
};
</script>
